module.exports = __webpack_public_path__ + "static/img/live_none.5dc72f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/live_none.png
// module id = T/yx
// module chunks = 1